export enum AddLabelStatus {
  REMOVE_LABEL = 'REMOVE_LABEL',
  ADD_LABEL = 'ADD_LABEL',
  LABEL_DOESNT_EXIST = 'LABEL_DOESNT_EXIST',
  NO_ACTION = 'NO_ACTION',
}

export function calculateHandleAddLabel(
  labelsIncludesNewLabel: boolean,
  isRemoveLabelsModal: boolean,
  clientLabelsIncludesNewLabel: boolean,
): AddLabelStatus {
  if (!labelsIncludesNewLabel) {
    if (isRemoveLabelsModal) {
      if (clientLabelsIncludesNewLabel) {
        return AddLabelStatus.REMOVE_LABEL;
      } else {
        return AddLabelStatus.LABEL_DOESNT_EXIST;
      }
    } else {
      return AddLabelStatus.ADD_LABEL;
    }
  }
  return AddLabelStatus.NO_ACTION;
}
